import React from 'react'
import { Card, CardActionArea, CardContent, CardMedia, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'

import generateTicketCardStyles from './css/generateTicketCardStyles'

const GenerateTicketCard = ({ imgSrc, title, subtitle, onCardClick }) => {
  const classes = generateTicketCardStyles()

  return (
    <Card onClick={onCardClick} className={classes.root}>
      <CardActionArea className={classes.cardActionArea}>
        <CardMedia className={classes.cover} image={imgSrc} title="Ticket Generate Image" />
        <CardContent className={classes.content}>
          <Typography variant="h6" className={classes.boldFont}>
            {title}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            {subtitle}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

GenerateTicketCard.propTypes = {
  imgSrc: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onCardClick: PropTypes.func,
}

GenerateTicketCard.defaultProps = {
  imgSrc: '',
  title: '',
  subtitle: '',
  onCardClick: () => {},
}

export default GenerateTicketCard
